import {Locale} from '../RootProvider/LocaleContext';

export enum EmailLanguage {
  nl = 'nl_NL',
  uk = 'en_EN',
}

// this is used to pass the correct Locale to the hrefLang
const getHrefLanguageFromLocale = (locale: Locale): EmailLanguage => {
  switch (locale) {
    case Locale.nl:
      return EmailLanguage.nl;
    case Locale.uk:
    default:
      return EmailLanguage.uk;
  }
};

export default getHrefLanguageFromLocale;
